import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
   selector: '[samwebLazyLoadIf]',
})
export class LazyLoadIfDirective {
   private hasView = false;

   constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

   @Input() set samwebLazyLoadIf(condition: boolean) {
      if (condition && !this.hasView) {
         this.viewContainer.createEmbeddedView(this.templateRef);
         this.hasView = true;
      }
   }
}
